var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register pt-4"},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-btn',{staticClass:"no-print mr-3",attrs:{"href":"https://dancestudio-pro.com/online/index.php?account_id=17992"}},[_vm._v("Register Online")])],1),_c('h2',[_vm._v("Studio Information and Policies")]),_c('studio-policy')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }